import { AppConstants } from "@/app.constants";
import { InspectionImageType } from "@/enums/InspectionImage.enum";
import { InspectionDefectStorage, InspectionDefectView } from "@/types/InspectionDefect";
import { generateUniqueId } from "./string.util";

/**
 * Builds a view from storage: parses imageUrls into existingImages for UI use.
 */
export function toDefectView(d: InspectionDefectStorage): InspectionDefectView {
    const urls = (d.imageUrls || "")
        .split(AppConstants.IMAGE_URL_SEPARATOR)
        .map((u) => u.trim())
        .filter(Boolean);

    return {
        ...d,
        existingImages: urls.map((url) => ({
            id: generateUniqueId(),
            url,
            type: InspectionImageType.DEFECT,
        })),
    };
}

/**
 * Converts a view back to storage: builds imageUrls from existingImages and strips UI-only fields.
 * Call this before passing a defect to onAdd/onEdit or persisting.
 */
export function toDefectStorage(view: InspectionDefectView): InspectionDefectStorage {
    const uploadedUrls = view.existingImages
        .filter((img) => !img.isDeleted)
        .map((img) => img.url)
        .filter(Boolean);

    const cleanedNewImages = (view.newImages || [])
        .filter(img => !img.isDeleted)
        .map(({ data, ...restImg }) => restImg);

    const { existingImages: _dropped, ...rest } = view;
    return {
        ...rest,
        newImages: cleanedNewImages,
        imageUrls:
            uploadedUrls.length > 0
                ? uploadedUrls.join(AppConstants.IMAGE_URL_SEPARATOR)
                : undefined,
    };
}
